<mat-spinner *ngIf="!init" color="primary" diameter="48"></mat-spinner>
<div *ngIf="init" class="container edit-project">
  <mat-horizontal-stepper
    #projectStepper
    *ngIf="
      project.id == null ||
      subProject?.status === STATUS.DRAFT.valueOf() ||
      !client
    "
    class="adjust-stepper-icons"
    [linear]="true"
  >
    <ng-template matStepperIcon="edit" let-index="index">
      {{ index + 1 }}
    </ng-template>

    <ng-template matStepperIcon="done" let-index="index">
      {{ index + 1 }}
    </ng-template>

    <mat-step [stepControl]="contactStepControl">
      <ng-template matStepLabel>Bedrijf</ng-template>
      <contact-picker
        [inputProject]="project"
        [client]="client"
        [adminCreate]="adminCreate"
        [ignoreIdSubmit]="true"
        (projectContactChange)="saveContacts($event)"
        (updateOtherContacts)="emitUpdateOtherContacts($event)"
        (next)="contactStepNext()"
      ></contact-picker>
    </mat-step>

    <mat-step [stepControl]="configurationStepControl">
      <ng-template matStepLabel>Configuratie</ng-template>
      <div class="">
        <client-product-wrapper
          *ngFor="let product of this.project.products; let index = index"
          [inputProject]="project"
          [inputProduct]="product"
          (productInitialized)="productInitialized($event, index)"
          (save)="save.emit()"
        >
        </client-product-wrapper>

        <mat-card
          *ngIf="
            (project.id == null ||
              project.subProjects[0].status === STATUS.DRAFT.valueOf()) &&
            showAddProduct
          "
          class="mat-elevation-z0 clickable overflow-hidden vertically-center"
          (click)="addProduct()"
        >
          <mat-icon
            class="plus-sign vertically-center"
            svgIcon="add"
          ></mat-icon>
          <span class="vertically-center">Onderdeel toevoegen</span>
        </mat-card>
      </div>

      <div class="flexer text-right">
        <button
          [disabled]="disallowProductStep()"
          class="button"
          (click)="finishConfigurationStep()"
          type="button"
          mat-button
        >
          Volgende
        </button>
      </div>
    </mat-step>

    <mat-step [stepControl]="designStepControl">
      <ng-template matStepLabel>Ontwerp</ng-template>

      <app-design-step-content
        [project]="project"
        [client]="client"
        (save)="save.emit()"
      ></app-design-step-content>

      <div class="flexer text-right">
        <button
          class="button"
          type="button"
          mat-button
          (click)="finishDesignStep()"
        >
          Volgende
        </button>
      </div>
    </mat-step>

    <mat-step [stepControl]="placementStepControl">
      <ng-template matStepLabel>Plaatsing</ng-template>

      <app-placement-step-content
        [project]="project"
        [subProject]="subProject"
        [client]="client"
        (save)="save.emit()"
      ></app-placement-step-content>

      <div class="flexer text-right">
        <button
          class="button"
          type="button"
          mat-button
          (click)="finishPlacementStep()"
        >
          Volgende
        </button>
      </div>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>Overzicht</ng-template>
      <client-base-project-summary
        *ngIf="project.products?.length > 0"
        [project]="project"
        [baseProject]="subProject"
        [submitProjectResult]="submitProjectResult"
        [client]="client"
        [placementProductAssets]="projectPlacementAssets"
        (save)="save.emit()"
        (submitProject)="submitProject.emit()"
      ></client-base-project-summary>
    </mat-step>
  </mat-horizontal-stepper>
  <div
    *ngIf="
      project.id != null &&
      client &&
      project.subProjects[0]?.status !== STATUS.DRAFT.valueOf()
    "
  >
    <client-base-project-summary
      *ngIf="project.products?.length > 0"
      [project]="project"
      [baseProject]="subProject"
      [client]="true"
      [placementProductAssets]="projectPlacementAssets"
      (save)="save.emit()"
      (submitProject)="submitProject.emit()"
    ></client-base-project-summary>
  </div>
</div>
